import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../Authservices/axiosInstance';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Button, Alert } from 'react-bootstrap';
import { IoInformationCircle } from "react-icons/io5";
import "./edit-hr.css";

const EditHR = () => {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [employee, setEmployee] = useState({
        name: '',
        username: '',
        role: '',
        email: '',
        department: '', // Initialize with an empty string
        joinDate: '',
        birthday: '',
        phone: '',
        country: '',
        city: '',
        address: '',
        status: '',
        jobTitle: '',
        workExperience: '',
        workDescription: '',
        gender: '',
        salary: '',
        idCardFront: '',
        idCardBack: '',
        cv: '',
        pastWorkCertificate: '',
    });
    const [departments, setDepartments] = useState([]);
    const [showAlert, setShowAlert] = useState(false);

    const roleOptions = ['Admin', 'Employee', 'HR'];
    const genderOptions = ['Male', 'Female', 'Other'];
    const statusOptions = ['Married', 'Single'];

    useEffect(() => {
        const fetchEmployee = async () => {
            try {
                const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/user/user/${userId}`);
                const employeeData = response.data;

                if (employeeData.joinDate) {
                    employeeData.joinDate = new Date(employeeData.joinDate).toISOString().split('T')[0];
                }
                if (employeeData.birthday) {
                    employeeData.birthday = new Date(employeeData.birthday).toISOString().split('T')[0];
                }

                setEmployee({
                    ...employeeData,
                    department: employeeData.department ? employeeData.department._id : '', // Store the department ID
                    idCardFront: employeeData.idCardFront || '',
                    idCardBack: employeeData.idCardBack || '',
                    cv: employeeData.cv || '',
                    pastWorkCertificate: employeeData.pastWorkCertificate || '',
                });
            } catch (error) {
                console.error('Error fetching employee data:', error);
            }
        };

        const fetchDepartments = async () => {
            try {
                const response = await axios.get(`https://backend.ems.uk.hiradentallab.com/api/departments/`);
                setDepartments(response.data);
            } catch (error) {
                console.error('Error fetching departments:', error);
            }
        };

        fetchEmployee();
        fetchDepartments();
    }, [userId]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEmployee((prevEmployee) => ({
            ...prevEmployee,
            [name]: value,
        }));
    };

    const handleFileChange = (e) => {
        const { name, files } = e.target;
        setEmployee((prevEmployee) => ({
            ...prevEmployee,
            [name]: files[0],
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            Object.keys(employee).forEach(key => {
                formData.append(key, employee[key]);
            });

            console.log('FormData to be sent:', Array.from(formData.entries())); // Check contents of FormData

            const response = await axios.put(`https://backend.ems.uk.hiradentallab.com/api/user/update/${userId}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            console.log('Response:', response); // Log the response to see if it's 204

            setShowAlert(true);
            setTimeout(() => {
                navigate('/emp-info');
            }, 3000);
        } catch (error) {
            console.error('Error updating employee data:', error);
        }
    };
  return (
    <div className="container-fluid">

      <h1 style={{ color: "#0353a4", fontSize: "2rem" }}>
        Edit {employee.name ? `${employee.name}'s` : 'Employee'} Info
      </h1>

      <div className="edit-emp-container">
        {/* Agar employee update ho jaye to Alert show kare */}
        {showAlert && (
          <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
            Employee updated successfully!
          </Alert>
        )}

        <Form onSubmit={handleSubmit}className='edit-emp-form'>
          <Row className="mb-3">
            <Form.Group as={Col} xs={12} md={6} controlId="name">
              <Form.Label>Name:</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={employee.name}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="username">
              <Form.Label>Username:</Form.Label>
              <Form.Control
                type="text"
                name="username"
                value={employee.username}
                onChange={handleChange}
                required
              />
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="role">
              <Form.Label>Role:</Form.Label>
              <Form.Control
                as="select"
                name="role"
                value={employee.role}
                onChange={handleChange}
                required
              >
                <option value="">Select Role</option>
                {roleOptions.map((role) => (
                  <option key={role} value={role}>
                    {role}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>

            <Form.Group as={Col} xs={12} md={6} controlId="email">
              <Form.Label>Email:</Form.Label>
              <Form.Control
                type="email"
                name="email"
                value={employee.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Row>

          {/* Employee Information Section */}
          <div>
            <h1
              style={{
                color: "#0353a4",
                textAlign: "left",
                fontSize: "2rem",
                marginTop: "30px",
              }}
            >
              <IoInformationCircle /> Employee Information
            </h1>
            <hr className="section-divider" />
          </div>

          {/* Rest of the form fields */}
          <Row className="mb-3">
          <Form.Group as={Col} xs={12} md={6} controlId="department">
                <Form.Label>Department:</Form.Label>
                <Form.Control
                    as="select"
                    name="department"
                    value={employee.department} // Bind department directly to the ID
                    onChange={handleChange}
                    required
                >
                    <option value="">Select Department</option>
                    {departments.map((dept) => (
                        <option key={dept._id} value={dept._id}>
                            {dept.name}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
            <Form.Group as={Col} xs={12} md={6} controlId="jobTitle">
              <Form.Label>Job Title:</Form.Label>
              <Form.Control
                type="text"
                name="jobTitle"
                value={employee.jobTitle}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Row>

        <Row className='mb-3'>
        <Form.Group as={Col} xs={12} md={6} controlId="joinDate">
          <Form.Label>Join Date:</Form.Label>
          <Form.Control
            type="date"
            name="joinDate"
            value={employee.joinDate}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} controlId="birthday">
          <Form.Label>Birthday:</Form.Label>
          <Form.Control
            type="date"
            name="birthday"
            value={employee.birthday}
            onChange={handleChange}
            required
          />
        </Form.Group>
        </Row>



        <Row classname="mb-3">
        <Form.Group as={Col} xs={12} md={6} controlId="phone">
          <Form.Label>Phone:</Form.Label>
          <Form.Control
            type="text"
            name="phone"
            value={employee.phone}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} controlId="country">
          <Form.Label>Country:</Form.Label>
          <Form.Control
            type="text"
            name="country"
            value={employee.country}
            onChange={handleChange}
          />
        </Form.Group>
        </Row>


        <Row className='mb-3'>
        <Form.Group as={Col} xs={12} md={6} controlId="city">
          <Form.Label>City:</Form.Label>
          <Form.Control
            type="text"
            name="city"
            value={employee.city}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} controlId="address">
          <Form.Label>Address:</Form.Label>
          <Form.Control
            type="text"
            name="address"
            value={employee.address}
            onChange={handleChange}
          />
        </Form.Group>
        </Row>


        <Row className="mb-3">
        <Form.Group as={Col} xs={12} md={6} controlId="status">
          <Form.Label>Status:</Form.Label>
          <Form.Control
            as="select"
            name="status"
            value={employee.status}
            onChange={handleChange}
          >
            <option value="">Select Status</option>
            {statusOptions.map((status) => (
              <option key={status} value={status}>
                {status}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} controlId="workExperience">
          <Form.Label>Work Experience:</Form.Label>
          <Form.Control
            type="text"
            name="workExperience"
            value={employee.workExperience}
            onChange={handleChange}
          />
        </Form.Group>
         </Row>
         

         <Row className='mb-3'>
        <Form.Group as={Col} xs={12} md={6} controlId="workDescription">
          <Form.Label>Work Description:</Form.Label>
          <Form.Control
            as="textarea"
            name="workDescription"
            value={employee.workDescription}
            onChange={handleChange}
          />
        </Form.Group>
        <Form.Group as={Col} xs={12} md={6} controlId="gender">
          <Form.Label>Gender:</Form.Label>
          <Form.Control
            as="select"
            name="gender"
            value={employee.gender}
            onChange={handleChange}
          >
            <option value="">Select Gender</option>
            {genderOptions.map((gender) => (
              <option key={gender} value={gender}>
                {gender}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
       
        <Form.Group as={Col} xs={12} md={6} controlId="salary">
          <Form.Label>Salary:</Form.Label>
          <Form.Control
            type="number"
            name="salary"
            value={employee.salary}
            onChange={handleChange}
          />
        </Form.Group>
        </Row>
        <Row className="mb-3">
  <Form.Group as={Col} controlId="cv">
    <Form.Label>Personal Documents:</Form.Label>
    {employee.cv && (
      <a href={`https://backend.ems.hiradentallab.com/uploads/${employee.cv}`} target="_blank" rel="noopener noreferrer">
        Current File: {employee.cv}
      </a>
    )}
    <Form.Control
      type="file"
      name="cv"
      onChange={handleFileChange}
    />
  </Form.Group>

  <Form.Group as={Col} controlId="workCertificate">
    <Form.Label>Company data protection contracts:</Form.Label>
    {employee.pastWorkCertificate && (
      <a href={`https://backend.ems.hiradentallab.com/uploads/${employee.pastWorkCertificate}`} target="_blank" rel="noopener noreferrer">
        Current File: {employee.pastWorkCertificate}
      </a>
    )}
    <Form.Control
      type="file"
      name="pastWorkCertificate"
      onChange={handleFileChange}
    />
  </Form.Group>
</Row>

<Row className="mb-3">
  <Form.Group as={Col} controlId="idCardFront">
    <Form.Label>Health and Safety certificates:</Form.Label>
    {employee.idCardFront && (
      <a href={`https://backend.ems.hiradentallab.com/uploads/${employee.idCardFront}`} target="_blank" rel="noopener noreferrer">
        Current File: {employee.idCardFront}
      </a>
    )}
    <Form.Control
      type="file"
      name="idCardFront"
      onChange={handleFileChange}
    />
  </Form.Group>

  <Form.Group as={Col} controlId="profilePhoto">
    <Form.Label>Handbook and Employement contracts:</Form.Label>
    {employee.profilePhoto && (
      <a href={`https://backend.ems.hiradentallab.com/uploads/${employee.profilePhoto}`} target="_blank" rel="noopener noreferrer">
        Current File: {employee.idCardFront}
      </a>
    )}
    <Form.Control
      type="file"
      name="profilePhoto"
      onChange={handleFileChange}
    />
  </Form.Group>



</Row>
        <Button type="submit">Update HR</Button>
      </Form>
    </div>
    </div>
  );
};

export default EditHR;
